// このファイルは自動生成されます。手動で編集しないでください。
// 生成スクリプト: scripts/generateTermsOfService.ts
// 生成コマンド: npm run generate:terms

export type TermsSection = {
  type: 'title' | 'section' | 'subsection' | 'paragraph' | 'list' | 'listItem';
  content: string;
  level?: number;
  items?: TermsSection[];
};

export const TERMS_OF_SERVICE_DATA: TermsSection[] = [
  {
    "type": "title",
    "content": "SiteNowサービスおよびソフトウェア利用許諾契約書"
  },
  {
    "type": "section",
    "content": "はじめに",
    "level": 0,
    "items": [
      {
        "type": "paragraph",
        "content": "本SiteNowサービスおよびソフトウェア利用許諾契約書 (以下「契約」という) は 株式会社トプコン及び株式会社トプコンソキアポジショニングジャパン (以下「TOPCON」という) と、[承諾] ボタンのクリック、アカウントの作成、またはログインにより本契約の規定を承諾した個人または団体 (以下「お客様」) との間で締結します。"
      },
      {
        "type": "paragraph",
        "content": "お客様が[承諾] ボタンをクリックするか、アカウントの作成またはログインしてTOPCON のサービスの利用を開始することにより、以下の規定に同意したものとし、その効力は同意した日から発生します。お客様が企業またはその他の組織の代理として本契約を締結する場合、お客様はその組織に本契約を遵守させる権限を持つことになります。その場合、「お客様」とは、その法人を指します。お客様が、当該の権限を所有していない場合、または本契約規定に同意しない場合、TOPCON のサービスを利用することはできません。さらに、TOPCON は、本契約に定められた規定への違反に対して、ただちに本契約を解除する権利、およびサービスを延期、取り消し、中断する権利を有します。"
      },
      {
        "type": "paragraph",
        "content": "本契約に基づき、TOPCON はお客様にクラウド上で提供されるソフトウェアサービスへのアクセスおよび利用を許諾いたします。本サービスには、ブラウザを介したインターフェース、データ暗号化、伝送、保管が含まれます。本サービスの利用は、本契約およびウェブサイトの「利用規約」に記載されている規約に従うものとします。ウェブサイトの利用規約は以下のURLでご確認いただけます。https://sitenow.asia/"
      }
    ]
  },
  {
    "type": "section",
    "content": "1.定義",
    "level": 1,
    "items": [
      {
        "type": "paragraph",
        "content": "本契約で使用されている用語:"
      },
      {
        "type": "paragraph",
        "content": "「契約」とは、本SiteNowサービスおよびソフトウェア利用許諾契約書を意味します。契約は、TOPCON が単独の裁量で適宜更新する可能性があります。"
      },
      {
        "type": "paragraph",
        "content": "「コンテンツ」とは、SiteNowサービスおよびソフトウェアに含まれる、またはSiteNowサービスを利用する過程でお客様がご利用いただける音声情報や視覚情報、文書、ソフトウェア、製品、サービスを意味します。"
      },
      {
        "type": "paragraph",
        "content": "「顧客データ」とは、お客様がサービスを利用する過程で、サービスに対して提供または送信するすべてのデータ、情報、資料を意味します。"
      },
      {
        "type": "paragraph",
        "content": "「発効日」とは、本契約が受諾された日、または、お客様がサービスの利用を開始された日のいずれか早い方を意味します。"
      },
      {
        "type": "paragraph",
        "content": "「利用開始日」とは、お客様が当サービスを利用可能となる最初の日とし、次のいずれかによって設定されます①お客様が利用申込書に記載された利用開始した希望日、もしくは②TOPCONがサービスの提供を開始した日。"
      },
      {
        "type": "paragraph",
        "content": "「利用期間」とは、お客様が購入した、発効日に開始されるサービスへのアクセス権の有効期間を意味します。"
      },
      {
        "type": "paragraph",
        "content": "「知的財産権」とは、特許で保護されていない発明、特許申請、特許、意匠権、著作権、商標、サービスマーク、商号、ドメイン名権、マスクワーク権、ノウハウ、その他の企業秘密権、その他のあらゆる知的財産権、そこからの派生物、および世界中のあらゆる場所における類似の性質を持つ保護形態を意味します。"
      },
      {
        "type": "paragraph",
        "content": "「サポートサービス」とは、TOPCON が適宜提供する、本サービスに対する追加サポートを意味します。かかるサポートサービスは、TOPCON が遠隔で提供するものとします。"
      },
      {
        "type": "paragraph",
        "content": "「サービス」とは、お客様が本契約の規約に基づきアクセス権を取得した TOPCON のSiteNowサービスおよびソフトウェアのご利用を意味します。"
      },
      {
        "type": "paragraph",
        "content": "「利用規約」とは、該当するサービスへのアクセスの際に経由するウェブサイトの利用について定める利用規約です。https://sitenow.asia/ にアクセスすると当該ウェブサイトをご利用いただけます。"
      },
      {
        "type": "paragraph",
        "content": "「ユーザー」とは、サービスの利用を許可され、お客様 (または、お客様のご要望により TOPCON) によってユーザー IDやユーザーアカウント およびパスワードを提供されたお客様の従業員、代表者、コンサルタント、請負業者、または代理人を意味します。"
      },
      {
        "type": "paragraph",
        "content": "「ユーザーライセンス」とは、お客様によるサービスの購入に関連してお客様が取得した個別のユーザーのサービスへのアクセス権を意味します。ユーザーライセンスは、契約が更新されない限り期間の満了または解除に伴い失効します。"
      }
    ]
  },
  {
    "type": "section",
    "content": "2.アクセスライセンスの付与と制限",
    "level": 1,
    "items": [
      {
        "type": "paragraph",
        "content": "TOPCON は、ここに、期間中サービスを利用するための非独占的、譲渡不可、世界的な  権利(以下第 20 条に規定する制限を条件とします)をお客様に付与します。これは、お客様独自の社内業務のみを目的としたものであり、本契約の規約を条件とします。TOPCON およびライセンサーは、お客様に対し明示的に付与されていないすべての権利を留保しています。これらの条項にお客様が違反した場合、TOPCON は、直ちに本ライセンスを停止する権利を行使できるものとします。"
      },
      {
        "type": "paragraph",
        "content": "お客様が TOPCON の競合他社である場合は、本サービスにアクセスできません。但し、TOPCON による事前の書面による同意がある場合は例外です。また、お客様は、TOPCON の書面による同意がない場合、サービスの可用性、パフォーマンス、機能を監視する目的として、またはその他のベンチマークまたは競合上優位に立つことを目的としてサービスにアクセスすることはできません。"
      },
      {
        "type": "paragraph",
        "content": "お客様は、(a) 競合製品またはサービスを作成するため、(b) サービスの類似するアイデア、特長、機能、または画像を使用して製品を作成するため、あるいは (c) サービスのあらゆるアイデア、特長、機能、またはグラフィックスをコピーするために以下を行うことはできません。"
      },
      {
        "type": "list",
        "content": "",
        "items": [
          {
            "type": "listItem",
            "content": "サービスまたはコンテンツを何らかの方法でライセンス供与、サブライセンス供与、売却、再販、移譲、譲渡、頒布したり、またはその他の方法で商業的に利用すること、もしくは第三者が利用できるようにすること。"
          },
          {
            "type": "listItem",
            "content": "サービスまたはコンテンツを改変したり、サービスまたはコンテンツを基に二次著作物を作成したりすること。"
          },
          {
            "type": "listItem",
            "content": "サービスに対するインターネット「リンク」を設けること、または他のサーバー、ワイヤレスデバイス、またはインターネットベースのデバイス上に、コンテンツの「フレーム」や「ミラー」を設けること。"
          },
          {
            "type": "listItem",
            "content": "サービスまたはその基礎となるコードに対してリバースエンジニアリングまたはアクセスを行うこと。"
          }
        ]
      },
      {
        "type": "paragraph",
        "content": "ユーザーライセンスは、2 名以上のユーザーで同時に共有したり利用したりすることはできませんが、退職した、または役職や職能が変更になりサービスを利用しなくなった以前のユーザーに取って代わる新しいユーザーに対しては、適宜、ユーザーライセンスの再割り当てを行うことができます。TOPCON からの書面による事前承認なく、パスワードの貸与または共有、あるいは本サービスや関連するあらゆる資料への第三者アクセスの許可を行ってはなりません。"
      },
      {
        "type": "paragraph",
        "content": "本サービスは、お客様の社内業務のみを目的としてご利用いただけます。また以下の行為を行ってはなりません。"
      },
      {
        "type": "list",
        "content": "",
        "items": [
          {
            "type": "listItem",
            "content": "適用される法律に違反するスパムメールまたは複製や迷惑メッセージの送信"
          },
          {
            "type": "listItem",
            "content": "子どもに害を与えたり第三者のプライバシー権を侵害したりするものを含め、権利を侵害する、猥褻、脅迫的、中傷的、またはその他の違法または不法な資料の送信または保管"
          },
          {
            "type": "listItem",
            "content": "ソフトウェアウイルス、ワーム、トロイの木馬やその他の有害なコンピュータコード、ファイル、スクリプト、エージェントまたはプログラムを含む資料の送信または保管"
          },
          {
            "type": "listItem",
            "content": "サービスやサービスに含まれているデータの整合性またはパフォーマンスの妨害や破壊"
          },
          {
            "type": "listItem",
            "content": "サービスまたはサービスに関連するシステムやネットワークへの不正アクセスの試行"
          }
        ]
      },
      {
        "type": "paragraph",
        "content": "サービスおよび TOPCON の業務に関連してお客様が知り得るサービス、内容およびあらゆる関連情報は本質的に機密です。お客様は、TOPCON の機密情報を保護するために合理的に必要なあらゆる予防措置を行い、お客様の最も貴重な機密情報に行う保護と同レベル以上の取り扱いを TOPCON の機密情報にも実施することに同意するものとします。"
      },
      {
        "type": "paragraph",
        "content": "TOPCON は、誤用、または本規約、利用規約または TOPCON と締結しているその他の契約に記載された規則に対する不遵守に関連する理由で、あるいは理由の有無を問わず、お客様が本サービスを利用する権利を直ちに、かつ遠隔で解除する権利を維持するものとします。さらに、TOPCON は、お客様が本サービスを利用する権利を直ちに、かつ遠隔で停止し、不適切な利用や、お客様の利用により TOPCON が民事責任や刑事責任を問われる可能性があると合理的に考えられるとする主張について調査を行う権利を維持します。"
      }
    ]
  },
  {
    "type": "section",
    "content": "3.お客様の責任",
    "level": 1,
    "items": [
      {
        "type": "paragraph",
        "content": "お客様は、ユーザーアカウントで生じるあらゆるアクティビティについて責任を負い、お客様が本サービスを利用することに関連して適用されるすべての現地法、州法、国法、外国法、協定、規則を遵守するものとします。これには、データプライバシー、国際通信、技術データや個人データの送信に関連するものも含まれます。お客様は、以下を守るものとします。"
      },
      {
        "type": "list",
        "content": "",
        "items": [
          {
            "type": "listItem",
            "content": "パスワードやアカウントの不正使用、その他のセキュリティ違反またはそれが疑われる場合、直ちに TOPCON に知らせること"
          },
          {
            "type": "listItem",
            "content": "お客様またはお客様のユーザーがコンテンツの複製または配信を行っている、またはそれが疑われる場合、TOPCON に直ちに知らせ、すぐに停止させるよう合理的努力を図ること"
          },
          {
            "type": "listItem",
            "content": "本サービスにアクセスするため、または本サービスを利用するために別のユーザーになりすましたり、虚偽の ID 情報を提供したりしないこと"
          }
        ]
      }
    ]
  },
  {
    "type": "section",
    "content": "4.TOPCON の責任",
    "level": 1,
    "items": [
      {
        "type": "paragraph",
        "content": "期間中、(i) TOPCON は、商業上合理的な努力を払い、本サービスの仕様やこれに関連した文書に従って、お客様にサービスを提供するものとします。(ii) TOPCON は、商業上合理的な努力を払い、常にお客様が本サービスをご利用いただけるようにします (TOPCON が定期メンテナンスを行っている間は除きます)。また、TOPCON は、商業上合理的な努力を払い、第三者が顧客データに不正アクセスしようとするのを防ぎます (このようなアクセスが、適用される法律または裁判所の要求に基づく場合は除きます)。TOPCON は、適宜、TOPCON のウェブベースのライセンスマネージャーに接続して、お客様の製品ライセンスや、お客様が本サービス、サポートサービスやその他のあらゆる関連サービスを利用する権利について確認するものとします。"
      }
    ]
  },
  {
    "type": "section",
    "content": "5.顧客データ",
    "level": 1,
    "items": [
      {
        "type": "subsection",
        "content": "5.1　(顧客データの所有権と面責)",
        "level": 2,
        "items": [
          {
            "type": "paragraph",
            "content": "あらゆる顧客データの正確性、品質、一貫性、合法性、信頼性、適切性、知的財産所有権、使用権については、TOPCON ではなく、お客様が単独で責任を負われるものとし、顧客データの削除、訂正、破壊、破損、損失、保管できなかったことについて TOPCON は責任を負わず、賠償もいたしかねます。お客様は、TOPCONが顧客データの返却義務（媒体の問わず、原本・コピー・複製・派生物を含む）を負わないことに同意します。当社は、契約期間中または契約終了後を問わず、顧客データの返却、移送、エクスポート、再提供等を行う義務を負いません。"
          },
          {
            "type": "paragraph",
            "content": "TOPCON は、お客様の不払などを含め、それに制限されないあらゆる違反に対し、通知なく、顧客データを保留、削除、破棄する権利を有します。契約の途中解除に際しては、お客様が顧客データにアクセスまたは利用する権利は直ちに停止され、TOPCON は、いかなる顧客データについても、維持または転送する義務がなくなるものとします。お客様は、TOPCON に対し、サポートサービスを目的として本サービスに含まれている顧客サービスにアクセスすることを許可するものとします。TOPCON は、具体的な顧客情報について特定せずに、統計やサービスのパフォーマンス改善を目的として、お客様のアカウントや資産使用情報について確認および使用する権利を有します。"
          }
        ]
      },
      {
        "type": "subsection",
        "content": "5.２　(顧客データの利用目的)",
        "level": 2,
        "items": [
          {
            "type": "paragraph",
            "content": "TOPCONは、本サービスの提供にあたり次のデータを収集します"
          },
          {
            "type": "paragraph",
            "content": "(i)現場データ"
          },
          {
            "type": "list",
            "content": "",
            "items": [
              {
                "type": "listItem",
                "content": "施工作業現場の建機に関する情報"
              },
              {
                "type": "listItem",
                "content": "施工現場の状況として取得される三次元位置データ、点群データ、画像データ"
              },
              {
                "type": "listItem",
                "content": "施工現場で使用されるセンサーに関する情報や取得されるデータ"
              },
              {
                "type": "listItem",
                "content": "施工履歴データや作業工程の進捗に関する情報"
              }
            ]
          },
          {
            "type": "paragraph",
            "content": "(ii)パーソナルデータ"
          },
          {
            "type": "list",
            "content": "",
            "items": [
              {
                "type": "listItem",
                "content": "利用会社名、利用者名、利用者メールアドレス"
              },
              {
                "type": "listItem",
                "content": "契約番号"
              },
              {
                "type": "listItem",
                "content": "利用開始日、利用期間"
              }
            ]
          },
          {
            "type": "paragraph",
            "content": "TOPCONは、以下の目的で顧客データを利用します。"
          },
          {
            "type": "list",
            "content": "",
            "items": [
              {
                "type": "listItem",
                "content": "(1)「ユーザー登録の確認・管理」"
              },
              {
                "type": "listItem",
                "content": "(2)「本サービスの提供・運営」"
              },
              {
                "type": "listItem",
                "content": "(3)「TOPCON製品・サービスの開発・改善」"
              },
              {
                "type": "listItem",
                "content": "(1)「ユーザー登録の状況の確認・管理」"
              }
            ]
          },
          {
            "type": "paragraph",
            "content": "お客様を識別し、登録情報を管理するために顧客データを利用します。"
          },
          {
            "type": "paragraph",
            "content": "利用例；"
          },
          {
            "type": "list",
            "content": "",
            "items": [
              {
                "type": "listItem",
                "content": "本サービスへの登録日、継続期間、解約日等を確認"
              },
              {
                "type": "listItem",
                "content": "お客様ごとに本サービス等の機能を提供するため、専用ページを設定"
              },
              {
                "type": "listItem",
                "content": "法人のお客様における担当者情報の追加・変更・削除等管理"
              },
              {
                "type": "listItem",
                "content": "スマートフォン等の端末の位置情報を本製品の位置情報として利用し、稼働場所を特定"
              },
              {
                "type": "listItem",
                "content": "個別のお客様へのカスタマーサポート対応"
              },
              {
                "type": "listItem",
                "content": "(2)「本サービスの提供・運営」"
              }
            ]
          },
          {
            "type": "paragraph",
            "content": "本サービスの実施のため、顧客データを利用します。"
          },
          {
            "type": "paragraph",
            "content": "利用例；"
          },
          {
            "type": "list",
            "content": "",
            "items": [
              {
                "type": "listItem",
                "content": "機器情報閲覧サービス：お客様ページで製品情報（購入日、稼働時間、エラー情報、位置情報）を公開"
              },
              {
                "type": "listItem",
                "content": "FW・OAFオンラインアップグレード：お客様ごとのアップデート情報に基づき、切り替えの案内および実施"
              },
              {
                "type": "listItem",
                "content": "(3)「本サービス／その他製品・サービスの改善・開発」"
              }
            ]
          },
          {
            "type": "paragraph",
            "content": "TOPCONおよびグループ会社の既存・将来の製品・サービス改善のためにパーソナルデータを利用します。"
          },
          {
            "type": "paragraph",
            "content": "利用例；"
          },
          {
            "type": "list",
            "content": "",
            "items": [
              {
                "type": "listItem",
                "content": "利用状況に関する統計データの作成・解析によるサービス改善"
              },
              {
                "type": "listItem",
                "content": "本サービス等に関するアンケートの実施"
              }
            ]
          }
        ]
      },
      {
        "type": "subsection",
        "content": "5.3　(パーソナルデータの安全管理)",
        "level": 2,
        "items": [
          {
            "type": "paragraph",
            "content": "TOPCONは、お客様から事前の同意を得た場合または法律で認められる場合を除き、パーソナルデータを第三者に提供、公開または共有しません。ただし、以下の場合には、国内外に存在する第三者に対し、パーソナルデータを移転することがあります。いずれの場合であっても、提供されるパーソナルデータの項目は5.2に記載の範囲及び目的を逸脱しません。"
          },
          {
            "type": "list",
            "content": "",
            "items": [
              {
                "type": "listItem",
                "content": "（1）グループ会社への提供"
              }
            ]
          },
          {
            "type": "paragraph",
            "content": "TOPCONは、TOPCONのグループ会社のうち、本サービスの実施のために必要な会社に対し、必要最低限のお客様のパーソナルデータを提供します。（「グループ会社」とは、TOPCONがその株式または持分の全部または過半数を直接または間接的に所有することにより、実質的にその意思決定機関を支配している会社をいいます。）"
          },
          {
            "type": "list",
            "content": "",
            "items": [
              {
                "type": "listItem",
                "content": "（2）ビジネスパートナー（代理店）への提供"
              }
            ]
          },
          {
            "type": "paragraph",
            "content": "TOPCONは、TOPCONのビジネスパートナー（TOPCON・グループ会社の製品・サービスを取り扱う販売代理店）のうち、本サービスの実施のために必要な会社に対し、必要最低限のお客様のパーソナルデータを提供します。"
          },
          {
            "type": "paragraph",
            "content": "なお、当該ビジネスパートナーとは、その選定にあたって適格性を十分審査し、契約にあたっては秘密保持義務や法令順守に関する義務を規定するとともに、当該会社においてパーソナルデータが適切に継続的に管理される体制づくりを行っております。"
          },
          {
            "type": "list",
            "content": "",
            "items": [
              {
                "type": "listItem",
                "content": "（3）業務委託先への提供"
              }
            ]
          },
          {
            "type": "paragraph",
            "content": "TOPCONは、本サービスの実施に必要な一部の作業（例：パーソナルデータの保存・管理、決済、配送、カスタマーサポート、等）を委託するため、業務委託先に対し、必要最低限のお客様のパーソナルデータを提供します。"
          },
          {
            "type": "paragraph",
            "content": "なお、当該業務委託先とは、その選定にあたって適格性を十分審査し、契約にあたっては秘密保持義務や法令順守に関する義務を規定するとともに、当該会社においてパーソナルデータが適切に継続的に管理される体制づくりを行っております。"
          },
          {
            "type": "list",
            "content": "",
            "items": [
              {
                "type": "listItem",
                "content": "（4）共同利用（日本国内のお客様のみ）"
              }
            ]
          },
          {
            "type": "paragraph",
            "content": "TOPCONは、以下の条件において、お客様のパーソナルデータを共同利用することがあります。"
          },
          {
            "type": "list",
            "content": "",
            "items": [
              {
                "type": "listItem",
                "content": "①\t共同利用されるパーソナルデータの項目：第X条に記載のとおり"
              }
            ]
          },
          {
            "type": "paragraph",
            "content": "共同利用する者の範囲：日本国内のグループ会社およびビジネスパートナー"
          },
          {
            "type": "paragraph",
            "content": "利用目的：第X条に記載のとおり"
          },
          {
            "type": "list",
            "content": "",
            "items": [
              {
                "type": "listItem",
                "content": "④\tパーソナルデータの管理についての責任者："
              }
            ]
          },
          {
            "type": "paragraph",
            "content": "（法人名）\t株式会社トプコン"
          },
          {
            "type": "paragraph",
            "content": "（住所）\t〒174-8580　東京都板橋区蓮沼町75-1"
          },
          {
            "type": "paragraph",
            "content": "（代表者）\t代表取締役社長　江藤　隆志"
          },
          {
            "type": "list",
            "content": "",
            "items": [
              {
                "type": "listItem",
                "content": "（5）第三国への移転"
              }
            ]
          },
          {
            "type": "paragraph",
            "content": "TOPCONは、サービス実施のためパーソナルデータの保存・管理を行うグループ会社および業務委託先が存在する第三国として、以下の海外移転先にお客様のパーソナルデータを移転いたします。"
          },
          {
            "type": "paragraph",
            "content": "海外移転先：米国カリフォルニア州"
          },
          {
            "type": "paragraph",
            "content": "なお、同州には個人情報の保護に関する制度として「カリフォルニア州消費者プライバシー法 2018年（CCPA）」が制定され、同法は2020年1月1日から施行されています。"
          },
          {
            "type": "paragraph",
            "content": "（個人情報保護委員会によるCCPAの紹介ページ：https://www.ppc.go.jp/enforcement/infoprovision/laws/CCPA/）"
          }
        ]
      },
      {
        "type": "subsection",
        "content": "5.4　Cookie（クッキー）について",
        "level": 2,
        "items": [
          {
            "type": "paragraph",
            "content": "本サービスでは、より良いコンテンツをご提供する目的でCookieを利用してお客様のコンピュータを識別する情報を取得している場合があります。"
          },
          {
            "type": "paragraph",
            "content": "本サービスで使用するCookieはお客様のプライバシーを侵害するものではなく、コンピュータへ悪影響を及ぼすことはありません。また、お客様ご自身が本ウェブサイトで個人情報を入力しない限り、個人を特定することはできません。ご利用のブラウザ設定などを変更することにより、Cookieの使用を禁止することも可能ですが、その場合は一部コンテンツもしくは機能をご利用できなくなることがありますのでご了承ください。"
          },
          {
            "type": "paragraph",
            "content": "なお、株式会社トプコンは、当社ウェブサイトの利用状況を計測・分析するため以下のツールを利用しております。"
          },
          {
            "type": "paragraph",
            "content": "Google Analytics"
          },
          {
            "type": "paragraph",
            "content": "Google Analyticsの利用規約"
          },
          {
            "type": "paragraph",
            "content": "https://marketingplatform.google.com/about/analytics/terms/jp/"
          },
          {
            "type": "paragraph",
            "content": "Googleのプライバシーポリシー"
          },
          {
            "type": "paragraph",
            "content": "https://policies.google.com/privacy?hl=ja"
          },
          {
            "type": "paragraph",
            "content": "HubSpot"
          },
          {
            "type": "paragraph",
            "content": "HubSpotの利用規約"
          },
          {
            "type": "paragraph",
            "content": "https://legal.hubspot.com/jp/terms-of-service"
          },
          {
            "type": "paragraph",
            "content": "HubSpotのプライバシーポリシー"
          },
          {
            "type": "paragraph",
            "content": "https://legal.hubspot.com/jp/privacy-policy"
          }
        ]
      }
    ]
  },
  {
    "type": "section",
    "content": "6.知的財産の所有権",
    "level": 1,
    "items": [
      {
        "type": "paragraph",
        "content": "サービス、コンテンツ、提案、アイデア、拡張リクエスト、派生物、修正、フィードバック、推奨、あるいはお客様または本サービスに関係する他のあらゆる当事者が提供するその他の情報のあらゆる権利、権原、利益は、関連の知的財産権を含めて TOPCON のみ (および該当する場合は TOPCON のライセンサー) が所有するものとします。本契約は、本サービスや、TOPCON が所有するあらゆる知的財産権に関連した所有権を売却するものではありません。TOPCON の社名およびロゴ、サービス名およびサービスロゴ、本サービスに関係する製品名は、TOPCON の商標であり、それらを使用する権利またはライセンスは供与しないものとします。"
      },
      {
        "type": "paragraph",
        "content": "なお、本契約の別表に記載されている第三者の技術を使用する権利は、TOPCONが別表に明示する当該第三者技術に関する許諾条件に従うものであり、本契約の条件には従いません。一方、別表に記載されていない第三者の技術を使用する権利については、本契約の条件に従うものとします。"
      }
    ]
  },
  {
    "type": "section",
    "content": "7.請求金額と料金の支払",
    "level": 1,
    "items": [
      {
        "type": "paragraph",
        "content": "お客様はすべての料金または支払いを、TOPCON若しくはTOPCONの販売代理店と合意した支払い方法で支払うものとします。初回ご請求金額は、利用申込書に記載の期間のユーザーライセンス料となります。支払は、書面による双方の同意がある場合を除き前払いとします。すべての支払義務は取り消すことができず、また支払済みのすべての金額は返金することができません。お客様は、ユーザーライセンスが現在使用中かどうかにかかわらず、契約期間全体について注文したすべてのユーザーライセンスについての支払責任を負われるものとします。 TOPCON は、お客様に 30 日以上前の事前通知を行うことにより、料金や請求金額の変更、および新しい請求金額の導入を随時行う権利を有します。"
      }
    ]
  },
  {
    "type": "section",
    "content": "8.クラウド上の利用環境及びデータストレージ",
    "level": 1,
    "items": [
      {
        "type": "paragraph",
        "content": "本サービスの利用期間中、TOPCONはお客様または契約番号ごとの利用環境をクラウド上に構築し、提供します。また、お客様には、クラウドサービスを含む本サービスに関連して、一定のストレージ容量が提供されます。ストレージ容量には上限があり、TOPCON は、クラウド環境を含む顧客データのストレージに関する運用方針や制限を新たに定め、または変更する権利を有します。"
      }
    ]
  },
  {
    "type": "section",
    "content": "9.請求および更新",
    "level": 1,
    "items": [
      {
        "type": "paragraph",
        "content": "本サービスの利用については、TOPCON は事前に請求および料金徴収を行い、お客様はTOPCONまたはその販売代理店と合意した支払い方法で支払うものとします。"
      },
      {
        "type": "paragraph",
        "content": "請求書に誤りがあると思われる場合は、請求額の調整や返金を受けられるように、疑問のある金額が記載された請求書の日付から 60 日以内に書面にてTOPCONまたはその販売代理店までご連絡ください。"
      }
    ]
  },
  {
    "type": "section",
    "content": "10.不払いおよび停止",
    "level": 1,
    "items": [
      {
        "type": "paragraph",
        "content": "お客様に対する請求金額が期限を過ぎて未払いとなっている (滞納) 場合、本契約で TOPCON に認められたその他の一切の権利に加え、TOPCON は、お客様の本サービスへのアクセスを直ちに解除または停止するか、あるいは本契約とお客様の本サービスへのアクセスを解除する権利を有します。未払いの請求書 (滞納金) については、未払金残高に対して毎月 1.0% または法律で認められた最高率のいずれか低い方の利息が課され、さらに回収にかかるあらゆる経費が加算されます。お客様には、停止期間中も引き続きユーザーライセンス料が請求されます。お客様または TOPCON のいずれかが本契約を解除した場合、お客様は、上記の「請求金額と料金の支払」の項に従って計算された残高の支払義務を負うものとします。"
      },
      {
        "type": "paragraph",
        "content": "TOPCON は、本サービスへのアクセスの停止または解除後にお客様が再度アクセスを求める場合には、再接続手数料を課す権利を留保します。お客様は、TOPCON には顧客データを保持する義務がなく、お客様の支払いが 30 日以上滞った場合、TOPCON はこのような顧客データを回復不可能な方法で削除する可能性があることを認識し、これに同意するものとします。"
      }
    ]
  },
  {
    "type": "section",
    "content": "11.期間 / 有効期間終了時の契約解除",
    "level": 1,
    "items": [
      {
        "type": "paragraph",
        "content": "本契約は発効日から開始され、TOPCON の独自の裁量でいつでも解除可能です。本契約が解除された (お客様の違反を理由とする場合を除く) 場合、お客様が解除の時点で要求することにより、TOPCON は解除発効日から 30 日以内は顧客データのファイルをお客様に提供するものとします。お客様は、TOPCON には顧客データを保持する義務がなく、解除から 30 日以上後には、TOPCON がこのような顧客データを削除する可能性があることを認識し、これに同意するものとします。また、TOPCON が、お客様の違反以外の理由で期間中に本契約を解除した場合、お客様は、その期間内の残り月数分の料金の返金を受ける権利を得るものとします。例えば、お客様が 1 年分の前払いをしていたとします。この 1 年間という期間のうち、TOPCON が本サービスを 7 カ月目で解除した場合、お客様は、期間中の残りの 5 カ月の料金の返金を受ける権利があることになります。"
      }
    ]
  },
  {
    "type": "section",
    "content": "12.正当な契約解除",
    "level": 1,
    "items": [
      {
        "type": "paragraph",
        "content": "TOPCON は、お客様の本契約への違反や他の不遵守の場合、独自の裁量で、お客様のパスワード、アカウント、または本サービスの使用を直ちに解除する場合があります。お客様は、TOPCON には顧客データを保持する義務がなく、お客様が本契約に違反した場合、TOPCON はこのような顧客データを削除する可能性があることを認識し、これに同意するものとします。違反には、未払い料金の支払不履行が含まれ、またこのような違反の通知から 15 日以内に当該違反が解決されなかった場合が含まれますが、これらに限定されません。"
      }
    ]
  },
  {
    "type": "section",
    "content": "13.表明と保証",
    "level": 1,
    "items": [
      {
        "type": "paragraph",
        "content": "各当事者は、本契約を締結する法的能力と権限を有することを表明、保証するものとします。お客様は、本サービスへのアクセスを得るために身分を偽ったり虚偽の情報を提供したりしていないこと、また請求先情報が正確であることを表明、保証するものとします。"
      }
    ]
  },
  {
    "type": "section",
    "content": "14.補償",
    "level": 1,
    "items": [
      {
        "type": "paragraph",
        "content": "次に挙げる事項に関連して生じる一切の請求、費用、損害、損失、責任、費用 (弁護士料や費用を含む) について、お客様が補償し、TOPCON、TOPCON のライセンサー、および各当事者の親会社、子会社、関連会社、役員、取締役、従業員、弁護士、代理人が被害を受けないようにするものとします。(I) 顧客データを使用することが、第三者の権利を侵害したり、第三者に被害をもたらしたりしたという一切の申立、(II) お客様が表明と保証に違反したこと、(III) お客様またはお客様のユーザーが本契約に違反したこと、(IV) 本サービスおよび関連アカウントの使用や誤用。"
      }
    ]
  },
  {
    "type": "section",
    "content": "15.保証免責",
    "level": 1,
    "items": [
      {
        "type": "paragraph",
        "content": "TOPCON および TOPCON のライセンサーは、本サービスまたは一切のコンテンツの信頼性、適時性、品質、持続性、真実、可用性、正確性、完全性について一切の表明、保証、誓約を行いません。TOPCON および TOPCON のライセンサーは、(A) 本サービスの使用が安全、適時、連続的またはエラーがないこと、または他のあらゆるハードウェア、ソフトウェア、システム、データとの組み合わせにおいて動作すること、(B) 本サービスがお客様の要件や期待に見合うこと、(C) 保管されたあらゆるデータが正確または信頼できること、(D) 本サービスを通じてお客様が購入または取得したあらゆる製品、サービス、情報やその他の資料の質がお客様の要件や期待に見合うこと、(E) エラーや欠陥が修正されること、(F) 本サービスまたは本サービスを利用可能にするサービスにウイルスやその他の害を与える要素がないことの表明や保証は行いません。本サービス、およびすべてのコンテンツは厳密に「現状有姿」で提供されます。すべての条件、表明および保証 (商品性、特定目的への適合性または第三者権利の非侵害の黙示的保証を含むがそれに限定されない) において、明示的、黙示的、または制定法上のいずれであるかにかかわらず、TOPCON と TOPCON のライセンサーは適用される法律に基づき認められる最大限の範囲で免責されるものとします。"
      }
    ]
  },
  {
    "type": "section",
    "content": "16.インターネットの遅延",
    "level": 1,
    "items": [
      {
        "type": "paragraph",
        "content": "TOPCON のサービスは、インターネットや電子的通信に内在する制限、遅延、およびその他の問題に影響を受ける場合があります。TOPCON はこのような問題から生じる遅延、配信障害、その他の損害について責任を負いません。"
      }
    ]
  },
  {
    "type": "section",
    "content": "17.責任の制限",
    "level": 1,
    "items": [
      {
        "type": "paragraph",
        "content": "TOPCON は、本サービス、ウェブサイト、または TOPCON のあらゆるウェブサイトの利用に関連して生じる不法行為、契約または他の不利益、またはTOPCON が提供する情報やサービスの信頼性 (サービスを利用することやサービスを利用できないことを含むが、それらに限定されない)、本サービスによって得たコンテンツ、コンテンツの中断、不正確性、誤りまたは不備 (原因を問わず) については、訴訟形態を問わず、利益、営業権、使用、データの損失、または他の無形損失、または直接的、間接的、特別、結果的、付随的、懲罰的な損害を含み、かつそれらに限定されない損害に対して、TOPCON がかかる損害の可能性を知らされていた場合でも、お客様または第三者に対して一切の責任を負いません。"
      },
      {
        "type": "paragraph",
        "content": "過失行為を含み、ただしこれに限定されないいかなる場合においても、TOPCON またはその関連会社、代理業者、従業員またはライセンサー (第三者プロバイダーを含む) は、(i) 本サービスの使用、不正使用または使用不能、(ii) 顧客データの保存の適時性、削除、誤配信または失敗、または (iii) 顧客データへの不正アクセスや不正改ざんに起因するあらゆる種類の損害に対して一切の責任を負いません。上記にかかわらず、TOPCON の責任が認められる場合における補償額の上限は、現行契約期間中にお客様が SiteNow サービス利用の対価として TOPCON に支払った総額を超えないものとします。"
      }
    ]
  },
  {
    "type": "section",
    "content": "18.不可抗力",
    "level": 1,
    "items": [
      {
        "type": "paragraph",
        "content": "本契約の下になされた TOPCON の遅延や不履行は、TOPCON の合理的な管理の及ばない出来事が引き起こしたものである場合に限り、本契約の違反とみなされないものとします。TOPCON の合理的な管理が及ばない出来事には、不可抗力、抑留、政府による規制、ストライキ、暴動、テロ、戦争またはその他の軍事活動、市民暴動、反乱、火災、洪水、暴力行為、停電、妨害行為などが含まれますが、これらのみに限定されません。市場の状況や変動は、不可抗力の出来事とはみなされません。TOPCON の履行がこのような出来事に影響を受ける場合、TOPCON は、不可抗力の状況を記述した通知を直ちに行い、履行を再開するためのあらゆる合理的努力を払うものとします。また、TOPCON の義務は、不可抗力に起因する範囲で保留され、不可抗力が継続する限り、影響を受けた義務の履行の期間は、このような不可抗力が引き起こした遅延の期間の分だけ延長されるものとします。不履行期間が、不可抗力の出来事の通知の受領日から 30 日を超える場合、TOPCON とお客様は、書面による通知を行うことで、本契約全体を何らの責任も負うことなく解除できるものとします。"
      }
    ]
  },
  {
    "type": "section",
    "content": "19.付加的権利",
    "level": 1,
    "items": [
      {
        "type": "paragraph",
        "content": "一部の法域では、偶発的、結果的、または特定のその他の種類の損害について、暗示的保証または限定の除外を認めていない場合があるため、上で規定した除外事項がお客様に適用されない場合があります。"
      }
    ]
  },
  {
    "type": "section",
    "content": "20.現地法と輸出管理",
    "level": 1,
    "items": [
      {
        "type": "paragraph",
        "content": "本サービスは、サービスを提供するものであり、日本国政府、アメリカ合衆国商務省、アメリカ合衆国財務省海外資産管理局、および、その他のアメリカ合衆国当局が管理する、日本国又はアメリカ合衆国の輸出管理の対象となる可能性のあるソフトウェアや技術を使用しています。日本国又はアメリカ合衆国が通商停止している国々 (以下総称して「禁輸対象国」という) またはその国民や在住者、またはアメリカ合衆国財務省の特別指定国民またはアメリカ合衆国商務省の取引禁止命令表 (以下総称して「指定国民」という) に記載されている人物や組織に対してはサイトを使用しないこと、また基本となる情報、ソフトウェアおよび技術の譲渡、輸出または再輸出を行わないことに同意するものとします。禁輸対象国や指定国民のリストは、通知なく変更されることがあります。本サービスを使用することにより、お客様は、お客様の拠点が禁輸対象国や指定国ではないこと、お客様がそれらの国の管理下にないこと、その国民または住民ではないことを表明・保証するものとします。お客様は、すべての日本国又はアメリカ合衆国の輸出法を厳密に遵守し、必要に応じて、輸出や再輸出を行うための免許取得について単独責任を負うことに同意されるものとします。"
      },
      {
        "type": "paragraph",
        "content": "本サービスは、輸出管理規制 15 C.F.R. Parts 730-774 および現行統一規制 Council Regulation (EC) No.1334/2000 に基づくライセンシング要件を条件とする暗号化技術を使用する場合があります。"
      },
      {
        "type": "paragraph",
        "content": "TOPCON と TOPCON のライセンサーは、本サービスが、他の地域において適切であるか、または利用可能であるかについて一切の表明を行いません。お客様が本サービスをアメリカ合衆国外から使用される場合、すべての適用法への遵守については、お客様が単独で責任を負うものとします。適用法には、その他の国々の輸出入規制が含まれますが、これらのみに限定されません。日本国又はアメリカ合衆国法に反するコンテンツの流用は禁止されています。"
      }
    ]
  },
  {
    "type": "section",
    "content": "21.プライバシー",
    "level": 1,
    "items": [
      {
        "type": "paragraph",
        "content": "TOPCON の適用されるプライバシーポリシーは、該当するサービスのウェブサイト (例: https://www.topcon.co.jp/privacy/) でご覧いただけます。TOPCON は、適宜、独自の裁量でこのプライバシーポリシーを修正する権利を有します。本サービスは、ホストされたオンラインアプリケーションであるため、TOPCON は、時々、サービスの運用に関する重要な告知を本サービスのユーザー全員に対して行う必要があることにご注意ください。"
      }
    ]
  },
  {
    "type": "section",
    "content": "22.通知",
    "level": 1,
    "items": [
      {
        "type": "paragraph",
        "content": "TOPCON は、TOPCON のアカウント情報に記録されているお客様のメールアドレス宛てに電子メールを送信するか、TOPCON のアカウント情報に記録されているお客様の住所に郵便により書面を送付することにより本サービスについての一般的な通知を行うことがあります。このような場合は、送付または投函から 48 時間後、またはメール送信 (メールで送付された場合) から 12 時間後に通知が受領されたものとみなされます。お客様は、ファックスまたは郵便で、随時 TOPCON に対して通知を行うことができます (このような通知は TOPCON の受領をもって行われたものとみなされます)。"
      }
    ]
  },
  {
    "type": "section",
    "content": "23.規約の修正",
    "level": 1,
    "items": [
      {
        "type": "paragraph",
        "content": "TOPCON は、適宜、本契約の規約や本サービスに関連したポリシーを修正する権利を有します。修正は、本サービスに関する本契約の更新版が投稿され次第有効となります。お客様には定期的に本契約を確認する責任があります。このような変更の後に本サービスを継続して使用することは、変更に引き続き同意するものとみなされます。"
      }
    ]
  },
  {
    "type": "section",
    "content": "24.譲渡、支配権の移転",
    "level": 1,
    "items": [
      {
        "type": "paragraph",
        "content": "お客様は、TOPCON の事前の書面による承諾なく本契約を譲渡することはできません。譲渡の意図が本項に違反する場合は無効となります。お客様の支配権の実際の変更または変更の提案によって TOPCON の直接の競合会社が直接的または間接的にお客様の支配権の 50% 以上を所有または支配することになる場合、TOPCON は、書面による通知をもって本契約を直ちに正当に解除する権利が与えられる物とします。"
      }
    ]
  },
  {
    "type": "section",
    "content": "25.一般事項",
    "level": 1,
    "items": [
      {
        "type": "paragraph",
        "content": "本契約は、抵触法の条項にかかわらず、日本国の法律に準拠し、解釈および実施されるものとします。何らかの理由で、本契約のいずれかの条項またはその一部分が法的強制力を失った場合、その条項は、本契約の目的を達成するために可能な限り執行されるものとし、本契約の残りの部分は継続して完全な強制力および効力を持つものとします。本契約に関する訴訟は、日本国東京地方裁判所を第一審の専属管轄裁判所とします。本契約は、ソフトウェアに関する弊社とお客様との間の完全な合意事項を構成するものであり、主題に関して TOPCON とお客様との間に過去または本契約の締結と同時になされたすべての通信、契約、理解に優先するものとします。本契約やサービスの使用の結果、お客様と TOPCON との間に合弁事業、パートナーシップ、雇用、代理店関係が存在することにはなりません。TOPCON が本契約の権利や条項のいずれかを履行しない場合にも、TOPCON が書面で通知および合意しない限り、権利や条項の放棄とはみなされません。本契約の印刷版は、司法または行政上の手続において認められます。"
      }
    ]
  },
  {
    "type": "paragraph",
    "content": "最終更新日:2026 年 ２月 １日"
  },
  {
    "type": "paragraph",
    "content": "別表　第三者の技術"
  },
  {
    "type": "paragraph",
    "content": "地理院タイル（国土地理院）　https://maps.gsi.go.jp/development/ichiran.html"
  }
];
